import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { FooterContent } from './FooterContent';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AssetStatusChangedFooter_NotificationGroupAccessRequestApproved_Fragment = { __typename?: 'NotificationGroupAccessRequestApproved' };

export type AssetStatusChangedFooter_NotificationGroupAccessRequestDenied_Fragment = { __typename?: 'NotificationGroupAccessRequestDenied' };

export type AssetStatusChangedFooter_NotificationGroupAccessRequestSubmitted_Fragment = { __typename?: 'NotificationGroupAccessRequestSubmitted' };

export type AssetStatusChangedFooter_NotificationGroupAssetAssignedToYou_Fragment = { __typename?: 'NotificationGroupAssetAssignedToYou' };

export type AssetStatusChangedFooter_NotificationGroupAssetStatusChanged_Fragment = { __typename?: 'NotificationGroupAssetStatusChanged', content: { __typename?: 'NotificationGroupContent', layout: { __typename?: 'NotificationLayout', footer?: Array<{ __typename?: 'NotificationLayoutItemAssetName' } | { __typename?: 'NotificationLayoutItemChip' } | { __typename?: 'NotificationLayoutItemProjectName' } | { __typename?: 'NotificationLayoutItemSection', content: Array<{ __typename?: 'NotificationLayoutItemAssetName' } | { __typename?: 'NotificationLayoutItemChip' } | { __typename?: 'NotificationLayoutItemProjectName', content: string } | { __typename?: 'NotificationLayoutItemSection' } | { __typename?: 'NotificationLayoutItemShareName', content: string } | { __typename?: 'NotificationLayoutItemText' } | { __typename?: 'NotificationLayoutItemTimestamp', content: string } | { __typename?: 'NotificationLayoutItemUserName' }> } | { __typename?: 'NotificationLayoutItemShareName' } | { __typename?: 'NotificationLayoutItemText' } | { __typename?: 'NotificationLayoutItemTimestamp' } | { __typename?: 'NotificationLayoutItemUserName' }> | null } } };

export type AssetStatusChangedFooter_NotificationGroupCommentCreated_Fragment = { __typename?: 'NotificationGroupCommentCreated' };

export type AssetStatusChangedFooter_NotificationGroupCommentCreatedShareAccess_Fragment = { __typename?: 'NotificationGroupCommentCreatedShareAccess' };

export type AssetStatusChangedFooter_NotificationGroupFileUploaded_Fragment = { __typename?: 'NotificationGroupFileUploaded' };

export type AssetStatusChangedFooter_NotificationGroupReplyCreated_Fragment = { __typename?: 'NotificationGroupReplyCreated' };

export type AssetStatusChangedFooter_NotificationGroupReplyCreatedShareAccess_Fragment = { __typename?: 'NotificationGroupReplyCreatedShareAccess' };

export type AssetStatusChangedFooter_NotificationGroupRequesterAccessRequestApproved_Fragment = { __typename?: 'NotificationGroupRequesterAccessRequestApproved' };

export type AssetStatusChangedFooter_NotificationGroupRequesterAccessRequestDenied_Fragment = { __typename?: 'NotificationGroupRequesterAccessRequestDenied' };

export type AssetStatusChangedFooter_NotificationGroupTranscriptCompletedSelf_Fragment = { __typename?: 'NotificationGroupTranscriptCompletedSelf' };

export type AssetStatusChangedFooter_NotificationGroupTransferBatchCompleted_Fragment = { __typename?: 'NotificationGroupTransferBatchCompleted' };

export type AssetStatusChangedFooter_NotificationGroupTransferBatchCompletedSelf_Fragment = { __typename?: 'NotificationGroupTransferBatchCompletedSelf' };

export type AssetStatusChangedFooter_NotificationGroupUserMentioned_Fragment = { __typename?: 'NotificationGroupUserMentioned' };

export type AssetStatusChangedFooter_NotificationGroupUserMentionedShareAccess_Fragment = { __typename?: 'NotificationGroupUserMentionedShareAccess' };

export type AssetStatusChangedFooterFragment = AssetStatusChangedFooter_NotificationGroupAccessRequestApproved_Fragment | AssetStatusChangedFooter_NotificationGroupAccessRequestDenied_Fragment | AssetStatusChangedFooter_NotificationGroupAccessRequestSubmitted_Fragment | AssetStatusChangedFooter_NotificationGroupAssetAssignedToYou_Fragment | AssetStatusChangedFooter_NotificationGroupAssetStatusChanged_Fragment | AssetStatusChangedFooter_NotificationGroupCommentCreated_Fragment | AssetStatusChangedFooter_NotificationGroupCommentCreatedShareAccess_Fragment | AssetStatusChangedFooter_NotificationGroupFileUploaded_Fragment | AssetStatusChangedFooter_NotificationGroupReplyCreated_Fragment | AssetStatusChangedFooter_NotificationGroupReplyCreatedShareAccess_Fragment | AssetStatusChangedFooter_NotificationGroupRequesterAccessRequestApproved_Fragment | AssetStatusChangedFooter_NotificationGroupRequesterAccessRequestDenied_Fragment | AssetStatusChangedFooter_NotificationGroupTranscriptCompletedSelf_Fragment | AssetStatusChangedFooter_NotificationGroupTransferBatchCompleted_Fragment | AssetStatusChangedFooter_NotificationGroupTransferBatchCompletedSelf_Fragment | AssetStatusChangedFooter_NotificationGroupUserMentioned_Fragment | AssetStatusChangedFooter_NotificationGroupUserMentionedShareAccess_Fragment;

export const AssetStatusChangedFooter = /*#__PURE__*/ gql`
    fragment AssetStatusChangedFooter on NotificationGroup {
  ... on NotificationGroupAssetStatusChanged {
    content {
      layout {
        ...FooterContent
      }
    }
  }
}
    ${FooterContent}` as unknown as DocumentNode<AssetStatusChangedFooterFragment, unknown>;

        

        
export const useAssetStatusChangedFooterFragment = (
  input: string | Omit<UseFragmentOptions<AssetStatusChangedFooterFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'NotificationGroup' } };
    return input;
  })();

  return useFragment<AssetStatusChangedFooterFragment>({
    fragment: AssetStatusChangedFooter,
    fragmentName: 'AssetStatusChangedFooter',
    ...options,
  });
};
  
        